module.exports = __webpack_public_path__ + "static/img/banner2.7d51cf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner2.png
// module id = YweD
// module chunks = 1